import React from 'react';
import PropTypes from 'prop-types';
import classes from './chip.module.scss';
import { ReactComponent as ClearSvg } from '../../../assets/icons/close.svg';

const Chip = ({ text = '', gray, onClear }) => (
  <div className={`${classes.wrapper} ${gray ? classes.gray : ''}`}>
    {text}

    {onClear && (
      <ClearSvg
        className={classes.clear__svg}
        onClick={onClear}
      />
    )}
  </div>
);

Chip.propTypes = {
  text: PropTypes.string,
  gray: PropTypes.bool,
  onClear: PropTypes.func,
};

export default Chip;
